import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useLenisContext } from '@providers/LenisProvider';

export const useScrollToTopSearch = () => {
  const [searchParams] = useSearchParams();
  const lenisRef = useLenisContext();

  useEffect(() => {
    if (!lenisRef?.current) return;

    lenisRef.current.scrollTo(0);
  }, [searchParams, lenisRef]);
};
